import Box from "@mui/material/Box";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  IS_ADLE_DOMAIN,
  TIME_LOADER_GENERATING_CAMPAIGN_ADVANCED,
} from "../../../../utils/constants";
import {
  CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION,
  CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM,
  CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS,
  CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS,
  CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION,
} from "../../../../i18n/keysTranslations";
import { logoPlatform } from "../../../../utils/string";
import { buildCampaignGeneratingLoaderLabels } from "../../../../utils/campaignGeneratingLoaderLabels";
import LinearLoaderWithTime from "../../../../components/Loaders/LinearLoaderWithTime";
import AnimatedImage from "../../../../components/Media/AnimatedImage";
import { AdleLogoLoader } from "../../../../assets/svg/AdleLogoLoader";

const CampaignGeneratingLoader = ({
  platformGenerating,
  objective,
  destinationType,
}) => {
  const { t } = useTranslationApp();
  const labels = buildCampaignGeneratingLoaderLabels({
    labels: [
      t(CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION),
      t(CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION),
      t(CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS),
      t(CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS),
    ],
    creatingInstantFormLabel: t(
      CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM
    ),
    platform: platformGenerating,
    objective,
    destinationType,
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        maxWidth: 500,
        mx: "auto",
        py: 2,
      }}
    >
      {!IS_ADLE_DOMAIN && (
        <AnimatedImage
          src={logoPlatform(platformGenerating)}
          sx={{
            width: 50,
            height: 50,
          }}
        />
      )}
      {IS_ADLE_DOMAIN && <AdleLogoLoader />}
      <LinearLoaderWithTime
        labelSide="bottom"
        time={TIME_LOADER_GENERATING_CAMPAIGN_ADVANCED}
        platform={platformGenerating}
        max={99}
        labels={labels}
      />
    </Box>
  );
};

export default CampaignGeneratingLoader;
